module.exports = __webpack_public_path__ + "img/top-bg-2.c086c663.png";